import Dialog from '~fpu/shared/components/Dialog';
import HLSVideoPlayer from '~fpu/shared/components/HLSVideoPlayer';
import { DownloadOutlinedIcon } from '@ramsey-design-system/icons';
import Button from '@ramsey-design-system/button';
import { analyticsLogger } from '~fpu/shared/utils/analytics';
import { VideoThumbnail } from '../VirtualClassResources';

// Types
export interface Video {
  ASSET_URL: string;
  THUMBNAIL_URL: string;
}

interface PromoteVideoModalProps {
  video: Video | null;
  playerId: number | null;
  isOpen: boolean;
  onClose: () => void;
}

interface PromoteVideoModalTriggerProps {
  video: Video;
  playerId: number;
  onTrigger: (video: Video, playerId: number) => void;
}

// Modal Component
export const PromoteVideoModal = ({
  video,
  playerId,
  isOpen,
  onClose
}: PromoteVideoModalProps) => {
  if (!video || playerId === null) return null;

  return (
    <Dialog onClose={onClose} open={isOpen} width="lg">
      <HLSVideoPlayer src={video.ASSET_URL} thumbnail={video.THUMBNAIL_URL} />

      <Dialog.Title level="2" className="mt-1 text-center">
        <Button
          data-testid="promote-video-download-link"
          appearance="subtle"
          element="a"
          href={video.ASSET_URL}
          icon={DownloadOutlinedIcon}
          onClick={() =>
            analyticsLogger.trackElementClicked({
              element: 'PromoVideoModal',
              label: 'Download Video'
            })
          }
        >
          Download Video
        </Button>
      </Dialog.Title>
    </Dialog>
  );
};

// Trigger Component
export const PromoteVideoModalTrigger = ({
  video,
  playerId,
  onTrigger
}: PromoteVideoModalTriggerProps) => {
  return (
    <div className="text-center">
      <div
        role="button"
        tabIndex={0}
        className="inline-block cursor-pointer"
        onClick={() => onTrigger(video, playerId)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onTrigger(video, playerId);
          }
        }}
      >
        <VideoThumbnail className="rounded-lg" thumb={video.THUMBNAIL_URL} />
      </div>
    </div>
  );
};
